var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencilSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon16/service/pencil-square",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.56757592,0 C8.8437183,0 9.06757592,0.223857625 9.06757592,0.5 C9.06757592,0.776142375 8.8437183,1 8.56757592,1 L8.56757592,1 L1.5,1 C1.22385763,1 1,1.22385763 1,1.5 L1,1.5 L1,14.5 C1,14.7761424 1.22385763,15 1.5,15 L1.5,15 L14.5,15 C14.7761424,15 15,14.7761424 15,14.5 L15,14.5 L15,6.58493492 C15,6.30879255 15.2238576,6.08493492 15.5,6.08493492 C15.7761424,6.08493492 16,6.30879255 16,6.58493492 L16,6.58493492 L16,14.5 C16,15.3284271 15.3284271,16 14.5,16 L14.5,16 L1.5,16 C0.671572875,16 0,15.3284271 0,14.5 L0,14.5 L0,1.5 C0,0.671572875 0.671572875,0 1.5,0 L1.5,0 Z M12.8197913,1.20994887 L12.91405,1.29295 L14.70705,3.08595 C15.0671787,3.44652208 15.0948809,4.01345787 14.7901566,4.40577821 L14.70705,4.5 L7.20705,12 L4,12 L4,8.79295 L11.5,1.29295 C11.8607612,0.933278421 12.4273624,0.905611376 12.8197913,1.20994887 Z M9.99965,4.2067 L5,9.20705 L5,11 L6.79295,11 L11.79295,6 L9.99965,4.2067 Z M12.20655,1.9995 L10.70665,3.4996 L12.5,5.29295 L14,3.79295 L12.20655,1.9995 Z",
    id: "Combined-Shape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilSquare);
export default __webpack_public_path__ + "static/media/pencil-square.929a9b6511e41c1a515b3873a1540024.svg";
export { ForwardRef as ReactComponent };